/**
 * Invite codes are 6 characters (A–Z, 2–9); older Android invites are 8. People
 * type them from a phone screen or a message, so spaces, dashes and lower case are
 * forgiven before the code is sent (CROSS_PLATFORM_CONTRACTS.md §6).
 */
export const INVITE_CODE_MIN_LENGTH = 6;
export const INVITE_CODE_MAX_LENGTH = 8;

export function normalizeInviteCode(raw: string): string {
  return raw.replace(/[\s-]+/g, '').toUpperCase();
}

export function isPlausibleInviteCode(code: string): boolean {
  return code.length >= INVITE_CODE_MIN_LENGTH && code.length <= INVITE_CODE_MAX_LENGTH;
}
